import * as Style from './LoadingSpinner.styles';
import { LoadingSpinnerProps } from './LoadingSpinner.types';

const LoadingSpinner = (props: LoadingSpinnerProps) => {
  return <Style.Container {...props} />;
};

export default LoadingSpinner;
